import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INQUIRY_FORM';

export const {
    action: createInquiry,
    success: createInquirySuccess,
    failed: createInquiryFailed,
} = createAction(`${domain}/CREATE_INQUIRY`, payload => ({payload}));
